module.exports = __webpack_public_path__ + "img/162-germany.ac4d7801.svg";